import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "toolbar", "count", "tagSelect", "statusSelect"]
  static values = { resourceType: String }

  connect() {
    this.updateToolbar()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.updateToolbar()
  }

  toggle() {
    this.updateSelectAll()
    this.updateToolbar()
  }

  updateSelectAll() {
    if (!this.hasSelectAllTarget) return
    const total = this.checkboxTargets.length
    const checked = this.selectedIds.length
    this.selectAllTarget.checked = checked === total && total > 0
    this.selectAllTarget.indeterminate = checked > 0 && checked < total
  }

  updateToolbar() {
    const count = this.selectedIds.length
    if (this.hasToolbarTarget) {
      this.toolbarTarget.classList.toggle("hidden", count === 0)
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = count
    }
  }

  get selectedIds() {
    return this.checkboxTargets.filter(cb => cb.checked).map(cb => cb.value)
  }

  exportSelected(event) {
    event.preventDefault()
    const ids = this.selectedIds
    if (ids.length === 0) return

    const url = new URL(window.location.href)
    url.searchParams.set("format", "csv")
    url.searchParams.set("ids", ids.join(","))
    window.location.href = url.toString()
  }

  // Le checkbox stanno fuori dal form della toolbar, quindi gli id vanno
  // iniettati come input nascosti mentre il submit è in corso — SENZA
  // annullarlo. L'entry list del form viene costruita dopo i gestori, e il
  // listener di Turbo è su document in bubbling, quindi vede le aggiunte.
  //
  // Annullare l'evento e richiamare form.requestSubmit() qui dentro NON
  // funziona: durante il dispatch del submit di quel form il browser ignora
  // requestSubmit in silenzio (guardia di rientranza dello standard HTML).
  // Nessun errore, nessuna richiesta: il pulsante sembra semplicemente morto.
  submitBulk(event) {
    const form = event.target.closest("form") || event.target
    const ids = this.selectedIds

    if (ids.length === 0) {
      event.preventDefault()
      return
    }

    form.querySelectorAll("input[name='ids[]']").forEach(el => el.remove())

    ids.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "ids[]"
      input.value = id
      form.appendChild(input)
    })
  }

  confirmDelete(event) {
    const count = this.selectedIds.length

    if (count === 0) {
      event.preventDefault()
      return
    }

    const message = `Eliminare ${count} ${count === 1 ? "elemento" : "elementi"} selezionati?`
    if (!confirm(message)) {
      event.preventDefault()
      return
    }

    this.submitBulk(event)
  }
}
